module.exports = __webpack_public_path__ + "static/media/ChineseNY11_01.8ca138f8.jpg";